import { useSchedulingLink } from 'components/use_scheduling_link'
import { useGetLandingPageQuery } from 'root-api'

export const useLandingPage = () => {
  const schedulingLink = useSchedulingLink()
  const { data: landingPage } = useGetLandingPageQuery(
    { uuid: schedulingLink?.owner_uuid },
    { skip: !schedulingLink || schedulingLink.owner_type !== 'LandingPage' }
  )

  if (schedulingLink === undefined) return undefined
  if (schedulingLink === null) return null

  if (schedulingLink.owner_type !== 'LandingPage') {
    return null
  }

  if (landingPage === undefined) return undefined
  if (landingPage === null) return null

  return landingPage
}
